import { CONVERGE_LINE_ITEMS, EndorsementUuid } from './line-item-uuids.enum';

import { CONVERGE_UUID } from './app-constants';

export const isEndorsementForExcess = (
  endorsementUuid: EndorsementUuid | string
) => {
  return (
    CONVERGE_LINE_ITEMS.endorsements?.edges.find(
      (edge) => edge.node.uuid === endorsementUuid
    )?.node.excess === true
  );
};

export const isEndorsementForPrimary = (
  endorsementUuid: EndorsementUuid | string
) => {
  return (
    CONVERGE_LINE_ITEMS.endorsements.edges.find(
      (edge) => edge.node.uuid === endorsementUuid
    )?.node.primary === true
  );
};

export const isConverge = (
  objectOrUuid: string | null | undefined | { uuid: string | null | undefined }
) => {
  if (typeof objectOrUuid === 'string') {
    return objectOrUuid === CONVERGE_UUID;
  }

  if (typeof objectOrUuid === 'object') {
    return objectOrUuid?.uuid === CONVERGE_UUID;
  }

  console.warn(
    'Warning: isConverge: objectOrUuid is not a string or object. Returning false.',
    objectOrUuid
  );

  return false;
};
